(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["natu-reviews"] && !Shopify.designMode) return;
  try {
    
  const initializeNatuReviews = (section) => {
    if (section.dataset.natuReviewsReady === 'true') return;
    const ratingId = section.dataset.natuReviewsRatingId;
    document.getElementById(ratingId)?.remove();
    const ratingTemplate = section.querySelector('[data-natu-reviews-title-template]');
    const productTitleBlock = document.querySelector('.product-information--product-page .product-details h1')?.closest('.text-block');
    if (ratingTemplate && productTitleBlock) {
      productTitleBlock.insertAdjacentElement('afterend', ratingTemplate.content.firstElementChild.cloneNode(true));
    }
    const viewport = section.querySelector('[data-natu-reviews-viewport]');
    if (!viewport) return;
    section.dataset.natuReviewsReady = 'true';

    const cards = Array.from(section.querySelectorAll('[data-natu-reviews-card]'));
    const previous = section.querySelector('[data-natu-reviews-prev]');
    const next = section.querySelector('[data-natu-reviews-next]');
    const search = section.querySelector('[data-natu-reviews-search]');
    const noResults = section.querySelector('[data-natu-reviews-no-results]');
    const pagination = section.querySelector('[data-natu-reviews-pagination]');
    const pageNumbers = section.querySelector('[data-natu-reviews-page-numbers]');
    const pagePrevious = section.querySelector('[data-natu-reviews-page-prev]');
    const pageNext = section.querySelector('[data-natu-reviews-page-next]');
    const pageStatus = section.querySelector('[data-natu-reviews-page-status]');
    const pageSize = 5;
    let currentPage = 1;

    const normalize = (value) => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase('pt-BR');
    const normalizedSearch = cards.map((card) => normalize(card.dataset.reviewSearch || ''));
    const matchingCards = () => {
      const query = normalize(search?.value.trim() || '');
      return cards.filter((_, index) => normalizedSearch[index].includes(query));
    };

    const showPage = (page) => {
      currentPage = page;
      render();
      viewport.scrollIntoView({
        block: 'start',
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      });
    };

    const renderPageNumbers = (pageCount) => {
      const fragment = document.createDocumentFragment();
      const pages = Array.from(new Set([1, pageCount, currentPage - 1, currentPage, currentPage + 1]))
        .filter((page) => page >= 1 && page <= pageCount)
        .sort((a, b) => a - b);

      pages.forEach((page, index) => {
        if (index > 0 && page > pages[index - 1] + 1) {
          const ellipsis = document.createElement('span');
          ellipsis.className = 'natu-reviews__page-ellipsis';
          ellipsis.setAttribute('aria-hidden', 'true');
          ellipsis.textContent = '…';
          fragment.append(ellipsis);
        }
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'natu-reviews__page-number';
        button.setAttribute('aria-label', `Página ${page}`);
        if (page === currentPage) button.setAttribute('aria-current', 'page');
        button.textContent = page;
        button.addEventListener('click', () => showPage(page));
        fragment.append(button);
      });
      pageNumbers.replaceChildren(fragment);
    };

    const render = () => {
      const matches = matchingCards();
      const pageCount = Math.max(1, Math.ceil(matches.length / pageSize));
      currentPage = Math.max(1, Math.min(currentPage, pageCount));
      const start = (currentPage - 1) * pageSize;
      const visibleCards = new Set(matches.slice(start, start + pageSize));

      cards.forEach((card) => {
        const shouldHide = !visibleCards.has(card);
        if (card.hidden !== shouldHide) card.hidden = shouldHide;
      });
      noResults.hidden = matches.length > 0;
      pagination.hidden = pageCount <= 1;
      if (previous) previous.disabled = currentPage === 1;
      if (next) next.disabled = currentPage === pageCount;

      if (!pagination.hidden) {
        pagePrevious.disabled = currentPage === 1;
        pageNext.disabled = currentPage === pageCount;
        pageStatus.textContent = `Página ${currentPage} de ${pageCount}`;
        renderPageNumbers(pageCount);
      } else {
        pageNumbers.replaceChildren();
        pageStatus.textContent = '';
      }
    };

    previous?.addEventListener('click', () => showPage(currentPage - 1));
    next?.addEventListener('click', () => showPage(currentPage + 1));
    search?.addEventListener('input', () => {
      currentPage = 1;
      render();
    });
    pagePrevious?.addEventListener('click', () => showPage(currentPage - 1));
    pageNext?.addEventListener('click', () => showPage(currentPage + 1));

    section.addEventListener('shopify:block:select', (event) => {
      const card = event.target.closest('[data-natu-reviews-card]');
      if (!card || !section.contains(card)) return;
      if (search) search.value = '';
      currentPage = Math.floor(cards.indexOf(card) / pageSize) + 1;
      render();
      card.scrollIntoView({ block: 'center' });
    });

    const onSectionUnload = (event) => {
      if (!event.target.contains(section)) return;
      document.getElementById(ratingId)?.remove();
      document.removeEventListener('shopify:section:unload', onSectionUnload);
    };
    document.addEventListener('shopify:section:unload', onSectionUnload);
    render();
  };

  document.querySelectorAll('[data-natu-reviews]').forEach(initializeNatuReviews);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-natu-reviews]').forEach(initializeNatuReviews);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["natu-wellness-banners"] && !Shopify.designMode) return;
  try {
    
  const initializeNatuBanners = (root) => {
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const slides = Array.from(root.querySelectorAll('[data-natu-slide]'));
    const dots = Array.from(root.querySelectorAll('[data-natu-dot]'));
    const autoplay = root.dataset.autoplay === 'true';
    const speed = Number(root.dataset.speed) * 1000;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const mobileMedia = window.matchMedia('(max-width: 749px)');
    let current = root.dataset.mobileFirst === 'second' && mobileMedia.matches && slides.length > 1 ? 1 : 0;
    let timer;

    const update = (index) => {
      current = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        const active = slideIndex === current;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
      });
      dots.forEach((dot, dotIndex) => {
        const active = dotIndex === current;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', String(active));
      });
    };

    const activate = (index) => {
      if (document.startViewTransition && !reducedMotion) {
        document.startViewTransition(() => update(index));
      } else {
        update(index);
      }
    };

    const stop = () => window.clearInterval(timer);
    const start = () => {
      stop();
      if (autoplay && !reducedMotion && slides.length > 1) {
        timer = window.setInterval(() => activate(current + 1), speed);
      }
    };

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        activate(Number(dot.dataset.natuDot));
        start();
      });
    });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);
    document.addEventListener('shopify:block:select', (event) => {
      const index = slides.findIndex((slide) => slide.dataset.blockId === event.detail.blockId);
      if (index >= 0) activate(index);
    });
    if (slides.length === 0) return;
    update(current);
    if (root.dataset.mobileFirst === 'second') {
      mobileMedia.addEventListener('change', () => {
        update(mobileMedia.matches && slides.length > 1 ? 1 : 0);
        start();
      });
    }
    start();
  };

  document.querySelectorAll('[data-natu-banners]').forEach(initializeNatuBanners);
  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('[data-natu-banners]');
    if (root) initializeNatuBanners(root);
  });

  } catch(e) { console.error(e); }
})();
})();
